import React from 'react';
import { sourceVisual } from './sourceVisuals';
import styles from './MarketingShared.module.css';

/** Quadrado com o ícone da origem (Instagram, Google, indicação...). */
function SourceAvatar({ name, size = 'md' }) {
  const { Icon, tone } = sourceVisual(name);
  return (
    <span className={`${styles.avatar} ${styles[`tone_${tone}`]} ${size === 'sm' ? styles.avatarSm : ''}`} aria-hidden="true">
      <Icon style={{ fontSize: size === 'sm' ? 14 : 20 }} />
    </span>
  );
}

/** Selo compacto com ícone + nome da origem, usado nas campanhas. */
export function SourceChip({ name }) {
  return (
    <span className={styles.chip}>
      <SourceAvatar name={name} size="sm" />
      <span className={styles.chipText}>{name}</span>
    </span>
  );
}

export default SourceAvatar;
